'use client';

import {useEffect, useRef} from 'react';

import {Container} from '@/modules/foundation/components/container';

import type {CookieDeclarationFragment} from './query';

interface Props {
	data: CookieDeclarationFragment;
}

export const CookieDeclaration = ({data}: Props) => {
	const {layout} = data ?? {};

	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = process.env.NEXT_PUBLIC_COOKIE_SCRIPT_REPORT ?? '';
			script.setAttribute('data-cookiescriptreport', 'report');
			containerRef.current.appendChild(script);
		}
	}, []);

	return (
		<Container spacingBottom={layout?.spacingBottom} spacingTop={layout?.spacingTop}>
			<div>
				{process.env.NODE_ENV !== 'development' && (
					<div
						ref={containerRef}
						className="[&_h4]:font-display [&_h4]:text-heading-sm [&_h4]:mt-8 [&_h4]:mb-4 [&_h4]:scroll-m-14 [&_h4]:font-semibold [&_table]:block [&_table]:overflow-x-auto"
					/>
				)}
			</div>
		</Container>
	);
};
